// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

// import Hotjar from 'vue-hotjar'
// import VueSocketIO from 'vue-socket.io'

import SocketIo from '@/plugins/SocketIo'
import i18n from '@/plugins/i18n'

import '@/assets/styles/index.css'

import Icon from '@/components/Icon'

require('dotenv').config()

router.beforeEach((to, from, next) => {
  store.dispatch('refresh')
    .then(() => {
      if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters.isLoggedIn) {
          next({ name: 'login' })
        } else {
          next() // go to wherever I'm going
        }
      } else {
        next() // does not require auth, make sure to always call next()!
      }
    })
})

Vue.component('Icon', Icon)

// Vue.use(Hotjar, {
//   id: '2092714' // Hotjar Site ID
// })

Vue.use(SocketIo)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router: router,
  store: store,
  components: { App },
  template: '<App/>',
  mounted () {
    window.socket = this.$socket
  },
  sockets: {
    connect () {
    },
    sync (data) {
      this.$store.commit('updatePlayer', data.config)
    }
  }
})
/* build 1784750401 */



// WEBPACK FOOTER //
// ./src/main.js